// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__SU--v","col":"Table_col__1zBky","fulfillmentStatus":"Table_fulfillmentStatus__W45C1","emailCol":"Table_emailCol__9CLJC"};